var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticStyle: { top: "20px" },
      attrs: {
        title: "数据授权",
        width: 800,
        height: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        "ok-disabled": _vm.disableSubmit,
        cancelText: "关闭"
      },
      on: { ok: _vm.handleSubmit, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "用户账号",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入用户账号", readOnly: true },
                    model: {
                      value: _vm.model.username,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "username", $$v)
                      },
                      expression: "model.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "组织权限",
                    required: true,
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-dropdown",
                    {
                      attrs: { trigger: [this.dropTrigger] },
                      on: { visibleChange: _vm.dropStatus }
                    },
                    [
                      _c(
                        "span",
                        { staticStyle: { "user-select": "none" } },
                        [
                          _c("a-tree", {
                            attrs: {
                              checkable: "",
                              multiple: "",
                              selectedKeys: _vm.selectedKeys,
                              checkedKeys: _vm.checkedKeys,
                              treeData: _vm.departTree,
                              checkStrictly: _vm.checkStrictly,
                              expandedKeys: _vm.iExpandedKeys,
                              autoExpandParent: _vm.autoExpandParent
                            },
                            on: {
                              check: _vm.onCheckDepart,
                              expand: _vm.onExpand
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }